import { OutputSelector } from '../output-selector/output-selector.interface';
import { Rule } from './rule';

export class ReplacerRule {
	public rules: Rule[] = [];

	constructor(public outputSelector: OutputSelector) { }
}
